import * as React from 'react';

export type SpinnerProps = {
    title:string;
}

export const Spinner = (props:SpinnerProps): JSX.Element => {

    return <div className={'c-rstats__loading'}>{props.title}<span className={'spinner'}></span></div>;
}
